import Popper from 'popper.js/dist/umd/popper.js';

window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = Popper;
    require('bootstrap');
} catch (e) {}


// WEBPACK FOOTER //
// ./resources/js/bootstrap.js